module.exports = __webpack_public_path__ + "media/images/samples/home/ep/ep4-41ad6539551ac3b5d8248c092e8e95e8.png";